/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import LeftPanel from "../components/LeftPanel";
import SetupModal from "../components/SetupModal";
import "../css/user.css";
import styles from "../css/SetupForm.module.css";
import axios from "axios";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { v4 as uuidv4 } from "uuid";
import { openDB } from "idb";
const Users = () => {
  const [isItemAvilableOpen, setIsItemAvilableOpen] = useState(false);

  const [editSetup, setEditSetup] = useState(false);
  const [NewSetup, setNewSetup] = useState(false);
  const [userID, setUserID] = useState("");
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  useEffect(() => {
    const getData = async () => {
      let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      let tx = db.transaction("user", "readwrite");
      let store = tx.objectStore("user");

      var usersData = await store.getAll();
      console.log("users", usersData)
      setUsers(usersData);

      tx = db.transaction("role_management", "readwrite");
      store = tx.objectStore("role_management");
      let roleData = await store.getAll();
      setRoles(roleData);
    };
    getData();
  }, [editSetup, NewSetup]);
  return (
    <>
      <LeftPanel
        setIsItemAvilableOpen={setIsItemAvilableOpen}
        isItemAvilableOpen={isItemAvilableOpen}
      />
      <Header />
      <div className="orders-report-container">
        <div id="heading">
          <h2>Users</h2>
        </div>

        <div className="table-container-user" style={{ height: "90vh", overflow: "scroll" }}>
          <table className="user-table">
            <thead>
              <tr>
                <th colSpan={2}>User Title</th>
                <th>Type</th>
                <th>Role</th>
                <th>MID</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users?.map((user) => (
                <tr key={Math.random()}>
                  <td colSpan={2}>{user.user_title || "-"}</td>
                  <td>
                    {+user.user_type === 1
                      ? "Admin"
                      : +user.user_type === 2
                        ? "Captain"
                        : +user.user_type === 3
                          ? "Chef"
                          : +user.user_type === 0
                            ? "Moderator"
                            : +user.user_type === 4
                              ? "SS User"
                              : +user.user_type === 5
                                ? "Organization"
                                : "-"}
                  </td>
                  <td>{roles.find(a => a.role_uuid === user.role_uuid)?.role_name || "-"}</td>
                  <td>{user.user_mid.slice(0, 11) || "-"}</td>
                  <td>{user.user_email || "-"}</td>
                  <td>{user.user_mobile_number || "-"}</td>
                  <td>
                    {+user.user_status === 1
                      ? "Enabled"
                      : +user.user_status === 0
                        ? "Disabled"
                        : "-"}
                  </td>
                  <td>
                    <button
                      className="fieldEditButton"
                      onClick={() => {
                        setUserID(user?.user_uuid);
                        setEditSetup(true);
                      }}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan={2}>
                  <button
                    className="fieldEditButton"
                    onClick={() => {
                      setNewSetup(true);
                    }}
                  >
                    Add New User
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          {editSetup && userID ? (
            <SetupModal
              onClose={() => {
                setEditSetup(false);
                setUserID("");
              }}
            >
              <UserEditForm
                onSave={() => {
                  setEditSetup(false);
                  setUserID("");
                }}
                userId={userID}
                roleData={roles}
              />
            </SetupModal>
          ) : (
            ""
          )}
          {NewSetup ? (
            <SetupModal
              onClose={() => {
                setNewSetup(false);
              }}
            >
              <NewUserForm
                onSave={() => {
                  setNewSetup(false);
                }}
                roleData={roles}
              />
            </SetupModal>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default Users;


function UserEditForm({ onSave, userId, roleData }) {
  const [userEditableData, setEditableUserData] = useState({});
  const [hiddenPassowrd, setHiddenPassowrd] = useState(true);
  const [itemGroups, setItemGroups] = useState([])

  const getUserData = () => {
    axios({
      method: "post",
      url: "https://api.myfooddo.com/user/getUserSummary",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: [
        {
          user_uuid: userId,
        },
      ],
    })
      .then((res) => {
        console.log(res);
        setEditableUserData(res.data.result[0]);
        if (+res.data.result[0]?.user_type !== 3) return;
        const getItemGroups = async () => {
          let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
          let tx = db.transaction("item_grouping", "readonly").objectStore("item_grouping");
          let groups = await tx.getAll()
          setItemGroups(groups)
        }
        getItemGroups()
        // setItemGroups
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getUserData();
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();
    axios({
      method: "put",
      url: "https://api.myfooddo.com/user/putUser",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: [
        {
          ...userEditableData,
        },
      ],
    })
      .then((res) => {
        console.log(res);
        updateLocalDb()
        onSave();
      })
      .catch((err) => console.log(err));
  };
  const updateLocalDb = async () => {
    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let tx = db.transaction("user", "readwrite");
    let store = tx.objectStore("user");
    store.put({ ...userEditableData, IDENTIFIER: userEditableData.user_uuid })
  }

  return (
    <div style={{ overflowY: "scroll" }}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.row}>
          <h1>Edit User</h1>
        </div>

        <div className={styles.formGroup}>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              User Name
              <input
                type="text"
                name="user_name"
                className={styles.numberInput}
                value={userEditableData?.user_name}
                disabled
              />
            </label>
            <label className={styles.selectLabel}>
              User MID
              <input
                type="text"
                name="user_mid"
                className={styles.numberInput}
                value={userEditableData?.user_mid}
                disabled
              />
            </label>
          </div>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              User Title
              <input
                type="text"
                name="user_title"
                className={styles.numberInput}
                value={userEditableData?.user_title}
                onChange={(e) =>
                  setEditableUserData({
                    ...userEditableData,
                    user_title: e.target.value,
                  })
                }
              />
            </label>
            <label className={styles.selectLabel}>
              User Email
              <input
                type="text"
                name="user_email"
                className={styles.numberInput}
                value={userEditableData?.user_email}
                onChange={(e) =>
                  setEditableUserData({
                    ...userEditableData,
                    user_email: e.target.value,
                  })
                }
              />
            </label>
          </div>
          <div className={styles.row}>
            <label
              className={styles.selectLabel}
              style={{ position: "relative" }}
            >
              User Password
              <input
                type={hiddenPassowrd ? "password" : "text"}
                name="user_password"
                className={styles.numberInput}
                value={userEditableData?.user_password}
                onChange={(e) =>
                  setEditableUserData({
                    ...userEditableData,
                    user_password: e.target.value,
                  })
                }
              />
              <div
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  left: "85%",
                  top: "50%",
                }}
              >
                {hiddenPassowrd ? (
                  <RemoveRedEyeIcon
                    style={{ fontSize: "18px" }}
                    onClick={() => setHiddenPassowrd(false)}
                  />
                ) : (
                  <VisibilityOffIcon
                    style={{ fontSize: "18px" }}
                    onClick={() => setHiddenPassowrd(true)}
                  />
                )}
              </div>
            </label>
            <label className={styles.selectLabel}>
              User Mobile
              <input
                type="text"
                name="user_mobile_number"
                className={styles.numberInput}
                value={userEditableData?.user_mobile_number}
                onChange={(e) =>
                  setEditableUserData({
                    ...userEditableData,
                    user_mobile_number: e.target.value,
                  })
                }
              />
            </label>
          </div>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              User Type
              <select
                name="user_type"
                className={styles.select}
                value={userEditableData?.user_type}
                onChange={(e) =>
                  setEditableUserData({
                    ...userEditableData,
                    user_type: e.target.value,
                  })
                }
                disabled
              >
                <option value="1">Admin</option>
                <option value="2">Captain</option>
                <option value="3">Chef</option>
                <option value="0">Moderator</option>
                <option value="4">SS User</option>
                <option value="5">Organization</option>
              </select>
            </label>
            <label className={styles.selectLabel}>
              User Status
              <select
                name="user_status"
                className={styles.select}
                value={userEditableData?.user_status}
                onChange={(e) =>
                  setEditableUserData({
                    ...userEditableData,
                    user_status: e.target.value,
                  })
                }
              >
                <option value="0">Inactive</option>
                <option value="1">Active</option>
              </select>
            </label>
          </div>
          <div className={styles.row}>
            {+userEditableData?.user_type === 2 ?
              <label className={styles.selectLabel}>
                Accepting Payment Allowed
                <select
                  name="accepting_payment_allowed"
                  className={styles.select}
                  value={userEditableData?.accepting_payment_allowed}
                  onChange={(e) =>
                    setEditableUserData({
                      ...userEditableData,
                      accepting_payment_allowed: e.target.value,
                    })
                  }
                  disabled={+userEditableData.user_type === 2 ? false : true}
                >
                  <option value="0" selected>
                    No
                  </option>
                  <option value="1" selected>
                    Yes
                  </option>
                </select>
              </label> :
              +userEditableData?.user_type === 1 ?
                <label className={styles.selectLabel}>
                  Select Role
                  <select
                    name="user_type"
                    className={styles.select}
                    value={userEditableData.role_uuid}
                    onChange={(e) =>
                      setEditableUserData({
                        ...userEditableData,
                        role_uuid: e.target.value,
                      })
                    }
                  >
                    <option defaultChecked={userEditableData.role_name === ""} >None</option>
                    {roleData.map(a => <option value={a.role_uuid}>{a.role_name}</option>)}
                  </select>
                </label>
                : +userEditableData?.user_type === 3 ?
                  <label className={styles.selectLabel}>
                    Select Item Group
                    <select
                      name="item_group_uuid"
                      className={styles.select}
                      value={userEditableData?.item_group_uuid || '0'}
                      onChange={(e) =>
                        setEditableUserData({
                          ...userEditableData,
                          item_group_uuid: e.target.value,
                        })
                      }
                    >
                      <option defaultChecked={!userEditableData?.item_group_uuid} value='0'>All</option>
                      {itemGroups?.map(a => <option value={a.item_group_uuid}>{a.item_group_title}</option>)}
                    </select>
                  </label>
                  : ''}
          </div>
        </div>

        <button type="submit" className={styles.submit}>
          Save changes
        </button>
      </form>
    </div>
  );
}

function NewUserForm({ onSave, roleData }) {
  const [userData, setUserData] = useState({});
  const [hiddenPassowrd, setHiddenPassowrd] = useState(true);
  const [errMassage, setErrorMassage] = useState("");
  const [itemGroups, setItemGroups] = useState([])

  useEffect(() => {
    setUserData({
      ...userData,
      user_mid: parseInt(uuidv4(), 16).toString(),
      user_status: "1",
      accepting_payment_allowed: "0",
      user_type: "2",
      outlet_uuid: localStorage.getItem("outlet_uuid"),
      role_uuid: "",
      user_uuid: uuidv4(),
    });

    const getItemGroups = async () => {
      let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      let tx = db.transaction("item_grouping", "readonly").objectStore("item_grouping");
      let groups = await tx.getAll()
      setItemGroups(groups)
    }
    getItemGroups()
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    axios({
      method: "post",
      url: "https://api.myfooddo.com/user/postUser",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: [{ ...userData, item_group_uuid: userData?.item_group_uuid || '0' }],
    })
      .then((res) => {
        console.log(res.data);
        if (res?.data?.result?.[0]?.success) {
          const getData = async () => {
            const user = res?.data?.result?.[0]?.userData || {}
            let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
            await db.transaction("user", "readwrite").objectStore("user").add({ ...user, IDENTIFIER: user?.user_uuid });
            onSave();
          };
          getData();
        } else {
          setErrorMassage('User with this username already exists');
        }
        setTimeout(() => setErrorMassage(""), 5000);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.row}>
          <h1>Add User</h1>
        </div>

        <div className={styles.formGroup}>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              User Name
              <input
                type="text"
                name="user_name"
                className={styles.numberInput}
                value={userData?.user_name}
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    user_name: e.target.value.replace(/\s/g, ""),
                  })
                }
                maxLength={42}
                required
              />
            </label>
            <label className={styles.selectLabel}>
              User MID
              <input
                type="text"
                name="user_mid"
                className={styles.numberInput}
                value={userData?.user_mid}
                disabled
              />
            </label>
          </div>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              User Title
              <input
                type="text"
                name="user_title"
                className={styles.numberInput}
                value={userData?.user_title}
                onChange={(e) =>
                  setUserData({ ...userData, user_title: e.target.value })
                }
                required
              />
            </label>
            <label className={styles.selectLabel}>
              User Email
              <input
                type="text"
                name="user_email"
                className={styles.numberInput}
                value={userData?.user_email}
                onChange={(e) =>
                  setUserData({ ...userData, user_email: e.target.value })
                }
                maxLength={42}
              />
            </label>
          </div>
          <div className={styles.row}>
            <label
              className={styles.selectLabel}
              style={{ position: "relative" }}
            >
              User Password
              <input
                type={hiddenPassowrd ? "password" : "text"}
                name="user_password"
                className={styles.numberInput}
                value={userData?.user_password}
                onChange={(e) =>
                  setUserData({ ...userData, user_password: e.target.value })
                }
                maxLength={42}
                required
              />
              <div
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  left: "85%",
                  top: "50%",
                }}
              >
                {hiddenPassowrd ? (
                  <RemoveRedEyeIcon
                    style={{ fontSize: "18px" }}
                    onClick={() => setHiddenPassowrd(false)}
                  />
                ) : (
                  <VisibilityOffIcon
                    style={{ fontSize: "18px" }}
                    onClick={() => setHiddenPassowrd(true)}
                  />
                )}
              </div>
            </label>
            <label className={styles.selectLabel}>
              User Mobile
              <input
                type="text"
                name="user_mobile_number"
                className={styles.numberInput}
                value={userData?.user_mobile_number}
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    user_mobile_number: e.target.value,
                  })
                }
                maxLength={42}
              />
            </label>
          </div>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              User Type
              <select
                name="user_type"
                className={styles.select}
                value={userData?.user_type}
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    user_type: e.target.value,
                  })
                }
                required
              >
                <option value="1">Admin</option>
                <option value="2">Captain</option>
                <option value="3">Chef</option>
              </select>
            </label>
            <label className={styles.selectLabel}>
              User Status
              <select
                name="user_status"
                className={styles.select}
                value={userData?.user_status}
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    user_status: e.target.value,
                  })
                }
                required
              >
                <option value="0">Inactive</option>
                <option value="1">Active</option>
              </select>
            </label>
          </div>
          <div className={styles.row}>
            {+userData?.user_type === 2 ? <label className={styles.selectLabel}>
              Accepting Payment Allowed
              <select
                name="accepting_payment_allowed"
                className={styles.select}
                value={userData?.accepting_payment_allowed}
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    accepting_payment_allowed: e.target.value,
                  })
                }
                disabled={+userData.user_type === 2 ? false : true}
              >
                <option value="0" selected>
                  No
                </option>
                <option value="1" selected>
                  Yes
                </option>
              </select>
            </label> :
              +userData?.user_type === 1 ? <label className={styles.selectLabel}>
                User Type
                <select
                  name="user_type"
                  className={styles.select}
                  value={userData.role_uuid}
                  onChange={(e) =>
                    setUserData({
                      ...userData,
                      role_uuid: e.target.value,
                    })
                  }
                >
                  <option defaultChecked={userData.role_name === ""}>None</option>
                  {roleData.map(a => <option value={a.role_uuid}>{a.role_name}</option>)}
                </select>
              </label> :
                +userData?.user_type === 3 ?
                  <label className={styles.selectLabel}>
                    Select Item Group
                    <select
                      name="item_group_uuid"
                      className={styles.select}
                      value={userData?.item_group_uuid || '0'}
                      onChange={(e) =>
                        setUserData({
                          ...userData,
                          item_group_uuid: e.target.value,
                        })
                      }
                    >
                      <option defaultChecked={!userData?.item_group_uuid} value='0'>All</option>
                      {itemGroups?.map(a => <option value={a.item_group_uuid}>{a.item_group_title}</option>)}
                    </select>
                  </label>
                  : ""}
          </div>
        </div>
        <i style={{ color: "red", padding:'5px' }}>{errMassage === "" ? "" : "Error: " + errMassage}</i>

        <button type="submit" className={styles.submit}>
          Save changes
        </button>
      </form>
    </div>
  );
}
